import { ReactNode } from 'react';

import { clsx } from 'clsx';

import cls from './ModalWrap.module.scss';

type ModalWrapProps = {
  children: ReactNode;
  fixed?: boolean;
};

export const ModalWrap = ({ children, fixed = true }: ModalWrapProps) => {
  return <div className={clsx(cls.wrap, { [cls.fixed]: fixed })}>{children}</div>;
};
